export const hydrateLinks = (text) => {
    const matches = text.match(
        /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi
    );
    matches?.forEach((m) => {
        text = text.replace(m, `<a href="${m}">${m}</a>`);
    });
    return text;
};
